import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const BookmarkFilled = createSvgIcon(
  <path d="M3.75 24V0h16.5v24L12 19.5 3.75 24Z" />,
  'BookmarkFilled'
);

export { BookmarkFilled };
